/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../components/Menu'
import Table from '../../../components/CategoryList'

import { useNavigate } from 'react-router-dom'

import { get } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'

import categoryIcon from '../../../assets/svg/categoryIcon.svg'

export default function index() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate()
  document.title = 'دسته بندی'

  const [categories, setCategories] = useState()
  const [categoriesCount, setCategoriesCount] = useState()
  const [totalPage, setTotalPage] = useState()
  const [name, setName] = useState()

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/categories/create')
  }

  const handlePageClick = (event) => {
    get(`/api/admin/categories?page=${event.selected + 1}&token=${token}`)
      .then(respose => {
        setCategories(respose.data.data.docs)
        setTotalPage(respose.data.data.pages)
        setCategoriesCount(respose.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }

  useEffect(() => {
    get(`/api/admin/categories?token=${token}`)
      .then(response => {
        setCategories(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setCategoriesCount(response.data.data.total)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const searchBtnHandler = () => {
    get(`/api/admin/categories/search/${name}?token=${token}`)
    .then(response => {
      setCategories(response.data.data)
      setTotalPage(0)
      setCategoriesCount(response.data.data.length)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  const getAllDataHandler = () => {
    get(`/api/admin/categories?token=${token}`)
      .then(response => {
        setCategories(response.data.data.docs)
        setTotalPage(response.data.data.pages)
        setCategoriesCount(response.data.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'category'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={categoryIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                لیست دسته بندی‌ها
              </div>
            </div>

            <div className="left">
              <button onClick={navigateHandler}>ایجاد دسته بندی</button>
            </div>
          </div>

          <div className="tablePart">
            <div className='search'>
              <label htmlFor="search">نام دسته بندی : </label>
              <input type="text" onChange={e => setName(e.target.value)}/>
              <button onClick={searchBtnHandler} style={{ margin: '0 0 0 1em' }}>جستجو</button>
              <button onClick={getAllDataHandler}>دریافت کل اطلاعات</button>
            </div>
            <hr />
            <div className="title">
              <div className="right">
                تعداد کل دسته بندی‌ها
              </div>
              <div className="left">
                {categoriesCount}
              </div>
            </div>

            <Table data={categories} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  );
}
